import axios from "axios";

export const getCopyright = async () => {
  return await axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/api/copyright`)
    .then((response) => response.data)
    .catch((error) => error);
};
